import { render, staticRenderFns } from "./NomineeInfo.vue?vue&type=template&id=04a1814d&scoped=true"
import script from "./NomineeInfo.vue?vue&type=script&lang=js"
export * from "./NomineeInfo.vue?vue&type=script&lang=js"
import style0 from "./NomineeInfo.vue?vue&type=style&index=0&id=04a1814d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1814d",
  null
  
)

export default component.exports